var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    className: "me-2",
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2489_11082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 2.72822C26.0071 3.18925 24.9405 3.50076 23.8191 3.64157C24.9761 2.91611 25.8417 1.77434 26.2544 0.429283C25.1674 1.10587 23.9777 1.58211 22.737 1.8373C21.9027 0.903854 20.7977 0.285149 19.5934 0.0772448C18.3891 -0.130659 17.1531 0.0838706 16.0771 0.687527C15.0011 1.29118 14.1454 2.25019 13.6429 3.41566C13.1403 4.58113 13.019 5.88786 13.2979 7.13296C11.0952 7.01707 8.9405 6.41717 6.97346 5.37219C5.00643 4.32721 3.27106 2.8605 1.87999 1.06725C1.40434 1.92702 1.13085 2.92385 1.13085 3.98547C1.13032 4.94118 1.35491 5.88224 1.78471 6.72517C2.21451 7.5681 2.83623 8.28684 3.59469 8.8176C2.71507 8.78827 1.85487 8.53922 1.08566 8.09116V8.16592C1.08557 9.50634 1.52805 10.8055 2.33801 11.843C3.14798 12.8804 4.27554 13.5923 5.52938 13.8578C4.71339 14.0892 3.85788 14.1233 3.02748 13.9575C3.38124 15.1109 4.07033 16.1194 4.99828 16.842C5.92623 17.5646 7.04659 17.965 8.2025 17.9872C6.24027 19.6013 3.81692 20.4769 1.32229 20.473C0.880397 20.4732 0.438873 20.4461 0 20.392C2.53219 22.0981 5.47984 23.0035 8.49027 23C18.681 23 24.252 14.1556 24.252 6.48502C24.252 6.23581 24.246 5.98411 24.2353 5.73491C25.3189 4.91374 26.2543 3.89687 26.9976 2.73196L27 2.72822Z",
    fill: "url(#paint0_linear_2489_11082)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2489_11082",
    x: 0,
    y: 0,
    width: 27,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_11082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2489_11082",
    x1: 13.5,
    y1: 0,
    x2: 13.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7293E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C99E3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon15.8d8db8c6286f30ea11bb977bc8ac999c.svg";
export { ForwardRef as ReactComponent };